import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./TillActivationPage.css";

const LOCAL_API_URL =
  process.env.REACT_APP_LOCAL_API_URL || "http://localhost:7000";

function TillActivationPage() {
  const navigate = useNavigate();

  const [activationCode, setActivationCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [activatedTill, setActivatedTill] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const cleanCode = activationCode.trim();

    if (!/^\d{6}$/.test(cleanCode)) {
      setError("Enter a valid 6-digit activation code.");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const response = await axios.post(
        `${LOCAL_API_URL}/tills/activate`,
        {
          activation_code: cleanCode,
          app_version: "1.0.0",
        },
        {
          timeout: 15000,
        }
      );

      setActivatedTill(response.data);
      setActivationCode("");
    } catch (err) {
      console.error("Till activation error:", err);

      setError(
        err.response?.data?.error ||
          "Till could not be activated."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="till-activation-page">
      <div className="till-activation-card">
        <h1>Activate This Till</h1>

        <p className="till-activation-description">
          Enter the 6-digit code generated from the DeskPOS
          admin dashboard.
        </p>

        {error && (
          <div className="till-activation-error">
            {error}
          </div>
        )}

        {!activatedTill ? (
          <form onSubmit={handleSubmit}>
            <label htmlFor="till-activation-code">
              Activation code
            </label>

            <input
              id="till-activation-code"
              type="text"
              inputMode="numeric"
              maxLength={6}
              placeholder="000000"
              value={activationCode}
              onChange={(event) => {
                const digitsOnly = event.target.value.replace(
                  /\D/g,
                  ""
                );

                setActivationCode(digitsOnly);
              }}
              autoFocus
            />

            <button type="submit" disabled={loading}>
              {loading ? "Activating..." : "Activate Till"}
            </button>
          </form>
        ) : (
          <div className="till-activation-success">
            <h2>Till activated successfully</h2>

            <div>
              <span>Shop</span>
              <strong>
                {activatedTill.shop_name || "DeskPOS Shop"}
              </strong>
            </div>

            <div>
              <span>Till</span>
              <strong>
                {activatedTill.till_name || "Till"}
              </strong>
            </div>

            <div>
              <span>Till code</span>
              <strong>
                {activatedTill.till_code || "—"}
              </strong>
            </div>

            <button
              type="button"
              onClick={() => navigate("/login")}
            >
              Continue to Login
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default TillActivationPage;